// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1UKez","title":"Images90_title__3HsD-","images":"Images90_images__32qc2"};